import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-content',
  templateUrl: './terms-content.component.html',
  styleUrls: ['./terms-content.component.css']
})
export class TermsContentComponent implements OnInit {

  SiteName ="WorldERP®";

  constructor() { }

  ngOnInit(): void {
  }

}
